import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useEffect, useRef } from 'react';

export default function StableWMSLayer() {
  const map = useMap();
  const layerRef = useRef(null);
  const MAP_LINK = process.env.REACT_APP_MAP_LINK || '';
  useEffect(() => {
    if (!layerRef.current) {
      layerRef.current = L.tileLayer.wms(
        MAP_LINK,
        {
          layers: 'default', // Specify the layer name from the WMS capabilities
          format: 'image/png',
          transparent: false,
          version: '1.3.0', // Optional: specify WMS version
          width: 256,
          height: 256,
        },
      );
      layerRef.current.addTo(map);
    }

    return () => {
      map.removeLayer(layerRef.current);
    };
  }, [map]);

  return null;
}
